<template>
  <div
    class="wrapper-report  "
    :style="{
      'z-index': '3'
    }"
  >
    <div class="mx-auto px-4 ">
      <page-breadcrumb
        :category="breadcrumbsCategory"
        :text="$i18nPresenter.t('Report')"
        :n-level-array="breadcrumbsMultipleLevelArray"
        @clickNLevel="clickBreadcrumbsNLevel"
        isSecondLevelClickable
        @clickSecondLevel="backToPreviousPage()"
        :title="presentation.name"
      />

      <div>
        <!--        info presentation start-->
        <div class="flex w-full wrapper-toolbox justify-between align-middle mb-4">
          <div class="section-info-presentation flex mt-2 mb-2  ">
            <Reactions
              :is-report="true"

              :presentation="presentation"
            />
            <span class=" min-w-max  flex items-center ">
              <aha-icon
                class="mr-1 base-color"
                name="slides"
                width="16"
                height="16"
                viewBox="0 0 12 12"
                v-tooltip="$i18nPresenter.t('Number of slides')"
              />
              <span>
                {{ presentation.slideCount }}
              </span>
            </span>

            <div class="flex  items-center  min-w-max time-box-report">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                class="mr-1"
              >
                <path d="M7.46814 5.93543V8.06336C8.29688 8.24771 9.03353 8.55081 9.80511 8.76017V6.62911C8.97955 6.44788 8.23655 6.14478 7.46814 5.93543ZM14.5584 2.09204C13.4693 2.58886 12.1294 3.08882 10.8434 3.08882C9.14467 3.08882 7.73804 2.00142 5.59793 2.00142C4.80413 2.00142 4.09605 2.13891 3.43878 2.37638C3.52768 2.14828 3.56896 1.90143 3.55308 1.63895C3.49593 0.751534 2.7561 0.0391002 1.85116 0.0016037C0.835086 -0.0390175 0 0.760908 0 1.75144C0 2.34514 0.301647 2.87009 0.762056 3.18568V15.2502C0.762056 15.6658 1.10181 16.0001 1.52411 16.0001H2.03215C2.45445 16.0001 2.7942 15.6658 2.7942 15.2502V12.3005C3.69279 11.9224 4.81365 11.6099 6.42667 11.6099C8.12859 11.6099 9.53205 12.6973 11.6722 12.6973C13.2026 12.6973 14.4251 12.188 15.5618 11.4193C15.8381 11.2318 16 10.9256 16 10.5944V2.9982C16.0032 2.27014 15.2316 1.78581 14.5584 2.09204ZM5.13117 10.1725C4.31196 10.2569 3.54356 10.4288 2.7942 10.6912V8.48832C3.62611 8.19772 4.30244 8.01961 5.13117 7.94462V10.1725ZM14.4791 5.9698C13.7297 6.27602 13.0089 6.57912 12.1421 6.71661V8.93828C12.9295 8.83204 13.7742 8.56956 14.4791 8.12585V10.3288C13.6821 10.8319 12.9391 11.1006 12.1421 11.1756V8.93828C11.2848 9.05389 10.6211 8.98515 9.80511 8.76329V10.8693C9.04623 10.6381 8.30323 10.3475 7.46814 10.2038V8.06336C6.84262 7.92587 6.17265 7.85088 5.13117 7.94462V5.75732C4.41992 5.85419 3.71502 6.07604 2.7942 6.41039V4.20746C3.84838 3.82625 4.38499 3.58877 5.13117 3.52003V5.75732C5.98849 5.64171 6.66799 5.7167 7.46814 5.93543V3.82937C8.22067 4.0606 8.96685 4.3512 9.80511 4.49494V6.63224C10.5576 6.79785 11.3165 6.84784 12.1421 6.71661V4.46994C12.9994 4.31995 13.8027 4.04498 14.4791 3.76688V5.9698Z" fill="#525F7F" />
              </svg>

              <div class="font-light">
                {{ moment(presentation.createdAt).format('DD MMM YYYY, hh:mm A') }}
              </div>
            </div>
          </div>

          <div class="flex gap-2">
            <span>
              <aha-button class="bg-white" :variant="'base'" @click="backToPresentation">
                <img src="@/assets/images/report/slide.svg" class="mr-1" />
                {{ $i18nPresenter.t('View slides') }}
              </aha-button></span>
            <ExportSection />
          </div>
        </div>
        <!-- info presentation end-->
        <!--        desktop 4 grid ipad 2 grid  -->
        <div class="grid md:grid-cols-2 xl:grid-cols-4  gap-4 mb-4 rounded-md  items-center">
          <div
            class="metric-box"
            v-hover-intent="{
              onEnter:() => {},
              onExit: () => trackingHereSection('Total participant',),
            }"
            @click="handleTabChange('participants')"
          >
            <img :src=" require('@/assets/images/report/audience.svg')" />
            <div class="flex flex-col gap-2 p-2">
              <div v-if="isLoadingReport" class="text-metric">
                <aha-skeleton-loader
                  width="100%"
                  height="20px"
                />
              </div>
              <div
                v-else-if="!isLoadingReport && reportMetric
                  && reportMetric.totalAudience !== 0 "
                class="text-metric"
              >
                {{ (reportMetric && reportMetric.totalAudience || 0 )| formatNumber }}
              </div>
              <div class="text-explain-metric">
                {{ reportMetric && reportMetric.totalAudience !== 0
                  ? $i18nPresenter.t('Total participants') : $i18nPresenter.t('No participants') }}
              </div>
            </div>
          </div>
          <div
            class="metric-box"
            @click="handleTabChange('feedback')"
            v-hover-intent="{
              onEnter:() => {},
              onExit: () => trackingHereSection('Ratings',),
            }"
          >
            <img :src=" require('@/assets/images/report/rating.svg')" />
            <div class="flex flex-col gap-2 p-2">
              <div v-if="isLoadingReport" class="text-metric">
                <aha-skeleton-loader
                  width="150px"
                  height="20px"
                />
              </div>
              <div
                v-else-if="!isLoadingReport && totalRatings > 0"
                class="text-metric flex flex-row justify-start items-center gap-2"
              >
                {{ avgRating }}
                <div>
                  <AhaStarRatingView
                    class="flex justify-center"
                    :rate="Number(avgRating)"
                    size="16px"
                  />
                </div>
              </div>
              <div v-if="isLoadingReport" class="text-metric">
                <aha-skeleton-loader
                  width="50px"
                  height="20px"
                />
              </div>
              <div class="text-explain-metric" v-else>
                {{ totalRatings === 0 ? $i18nPresenter.t('No ratings') : (totalRatings > 1
                  ? $i18nPresenter.t('x ratings', { number: totalRatings })
                  : $i18nPresenter.t('x rating', { number: totalRatings })
                ) }}
              </div>
            </div>
          </div>

          <div
            class="metric-box"
            v-hover-intent="{
              onEnter:() => {},
              onExit: () => trackingHereSection('Avg. submissions',),
            }"
            @click="handleTabChange('participants')"
            v-tooltip="{content: tooltipGuide, html: true}"
          >
            <img :src="require('@/assets/images/report/submisstion.svg')" />
            <div class="flex flex-col gap-2 p-2">
              <div v-if="isLoadingReport" class="text-metric">
                <aha-skeleton-loader
                  width="100%"
                  height="20px"
                />
              </div>
              <div v-else-if="noSubmission" class="text-metric">
                {{ formatNumberForMetric(reportMetric && reportMetric.averageSubmissionCount ) | formatNumber }}
              </div>
              <div class="text-explain-metric">
                {{ noSubmission ? $i18nPresenter.t('Avg. submissions') : $i18nPresenter.t('No submissions') }}
              </div>
            </div>
          </div>
          <div
            class="metric-box"
            v-hover-intent="{
              onEnter:() => {},
              onExit: () => trackingHereSection('Accuracy',),
            }"
            @click="handleTabChange('participants')"
          >
            <img :src="require('@/assets/images/report/accuracy.svg')" />
            <div class="flex flex-col gap-2 p-2">
              <div v-if="isLoadingReport" class="text-metric">
                <aha-skeleton-loader
                  width="100%"
                  height="20px"
                />
              </div>
              <div class="text-metric" v-else-if="!isLoadingReport && noAnswer">
                {{ reportMetric && Math.round(((reportMetric && reportMetric.totalAccuracy) || 0 ) * 100) }} %
              </div>
              <div class="text-explain-metric">
                {{ noAnswer
                  ? $i18nPresenter.t('Accuracy') : $i18nPresenter.t('No answers') }}
              </div>
            </div>
          </div>
        </div>
        <div class="wrapper-table">
          <div class="modal__title--tab title-tab__content-wrapper">
            <a
              @click="handleTabChange('participants')"
              class="title-tab__content"
              :class="{ active: selectedTab === 'participants' }"
            >
              {{ $i18nPresenter.t('Participants') }} <span class="inline-block" v-if="isLoadingReport">
                <aha-skeleton-loader
                  width="20px"
                  height="15px"
                />
              </span>
              <span v-else class="ml-2">({{ (reportMetric && reportMetric.totalAudience || 0 ) | formatNumber }})</span>
            </a>
            <a
              @click="handleTabChange('feedback')"
              :class="{ active: selectedTab === 'feedback' }"
              class="title-tab__content"
            >
              {{ $i18nPresenter.t('Feedback') }} <span class="inline-block" v-if="isLoadingReport">
                <aha-skeleton-loader
                  width="20px"
                  height="15px"
                />
              </span>
              <span v-else class="ml-2">({{ feedbackList.length || 0 }})</span>
            </a>
          </div>
          <ReportPrivateFeedbackV2
            v-if="selectedTab === 'feedback'"
            :oldFeedbacks="privateFeedbacks"
            :newFeedbacks="newPrivateFeedbacks"
          />
          <ListParticipant
            v-if="selectedTab === 'participants'"
            :audienceReport="audienceReport"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// components
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import constants from '@/constant'
import ExportSection from '@/components-v2/presentation-report/ExportSection.vue'
import Config from '@/config'
import Socket from '@/socket'
import EventBus from '@/eventBus'
import socketHelper from '@/helpers/socket/socket-helper'
import PresentationEditorSocketHandler from '@/utils/presentationEditorSocketHandler.v2'
import ReportPrivateFeedbackV2 from '@/components-v2/presentation-report/ReportPrivateFeedbackV2.vue'
import Reactions from '@/components-v2/my-presentations/main-table/Reactions.vue'
import ListParticipant from '@/components-v2/presentation-report/ListParticipant.vue'
import PageBreadcrumb from '@/components-v2/common/page-breadcrumb/PageBreadcrumb.vue'
import Utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import ReportMixin from '@/components-v2/presentation-report/ReportMixin'
/**
 * @deprecated Use ReportPageV2 instead
 */
export default {
  components: {
    PageBreadcrumb,
    Reactions,
    ReportPrivateFeedbackV2,
    ExportSection,
    ListParticipant,
  },
  mixins: [ReportMixin],

  data() {
    return {
      data: null,
      selectedTab: 'engagingSlides',
      tabs: [],
      linkDownload: '',
      loading: false,
      loadingClearData: false,
      loadingDuplicate: false,
      loadingExportPdf: false,
      loadingExportExcel: false,
      isShowReport: false,
      ctaUpgradePro: false,
      exportDonePdf: false,
      exportDoneImage: false,
      exportDoneExcel: false,
      role: constants.role,
    }
  },

  computed: {
    moment() {
      return moment
    },
    ...mapGetters('presentationReport', [
      'presentationReport',
      'selectedPresentation',
      'isLoadingReport',
      'reportError',
      'connectionError',
      'isShowReportPanel',
      'avgCorrectRate',
      'mostDifficultQuestions',
      'engagementRate',
      'engagementLevel',
      'totalInteractions',
      'totalReactions',
      'privateFeedbacks',
      'newPrivateFeedbacks',
      'audienceReport',
      'isPreviousRouteTeamFolderDetails',
      'isPreviousShareRouteFolderDetails',
      'isPreviousRouteTeam',
      'isPreviousRouteSharedWithMe',
    ]),
    ...mapGetters('multipleSessions', ['canUseMultipleSessions', 'selectedSession']),
    ...mapState({
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      slideActive: (state) => state.slideActive,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
      breadcrumbsMultipleLevelsArray: (state) => state.breadcrumbsMultipleLevelsArray,
      audienceReportSummary: (state) => state.presentationReport.audienceReportSummary,
      locale: (state) => state.presenterLocale,
    }),
    noSubmission() {
      return !this.isLoadingReport && this.reportMetric && this.reportMetric.averageSubmissionCount !== 0
    },
    noAnswer() {
      return (this.reportMetric && (this.reportMetric.totalAccuracy > 0
          || this.reportMetric.totalInCorrectAnswers > 0
          || this.reportMetric.totalCorrectAnswers > 0))
    },
    tooltipGuide() {
      return `
          <div>${this.titleGuide}:</div>
              <ul style='list-style-type:circle;margin-left:12px'>
            <li>Poll & Scales votes</li>
            <li>Open-ended answers</li>
            <li>Brainstorm & Word cloud answers</li>
            <li>QnA questions</li>
            </ul>
            `
    },
    titleGuide() {
      return this.$i18nPresenter.t('Average submission count includes')
    },
    numberOfReactions() {
      const {
        numberOfLikes,
        numberOfHearts,
        numberOfLaughs,
        numberOfWows,
        numberOfSads,
      } = this.presentation

      return numberOfLikes + numberOfHearts + numberOfLaughs + numberOfWows + numberOfSads
    },
    breadcrumbsCategory() {
      if (this.isPreviousRouteTeam || this.isPreviousRouteTeamFolderDetails) {
        return this.currentAccount.name
      }
      if (this.isPreviousRouteSharedWithMe || this.isPreviousShareRouteFolderDetails) {
        return this.$i18nPresenter.t('Shared with Me')
      }
      return this.$i18nPresenter.t('My Presentations')
    },
    breadcrumbsMultipleLevelArray() {
      // if (this.isPreviousRouteTeamFolderDetails) {
      //   return this.selectedFolder ? [this.selectedFolder] : []
      // }
      return (this.breadcrumbsMultipleLevelsArray && this.breadcrumbsMultipleLevelsArray.length)
        ? this.breadcrumbsMultipleLevelsArray : []
    },
  },

  async mounted() {
    this.setDefaultTabInEditor()
    await this.getPresentationDetailBySession()

    this.setLoadingExportPdfAction(false)
    this.setLoadingExportImageAction(false)
    this.setLoadingExportExcelAction(false)
    await this.selectPresentationAction({
      presentation: this.presentation,
    })
    socketHelper.joinRoomPresentation(this.presentation.uniqueAccessCode)
    this.initSocket(this.presentation.uniqueAccessCode)
    this.subscribeReportAction(this.presentation)
  },

  destroyed() {
    this.clearPresentationReportAction()
    PresentationEditorSocketHandler.disconnectSocket(this)
    this.$store.state.presentation.id = null
    EventBus.$off('getDataPresentationDetail')

    this.$store.state.audiences = {}
    this.$store.state.userOnline = 0
    this.$store.state.questions = []
    this.$store.state.tabQnaQuestion = 1
    this.$store.state.lastQuestion = {}
    this.$store.state.questionCount = 0
    this.$store.state.showLiveAudienceDemo = false
    this.$store.state.showQnaSession = false
    this.$store.state.presentationEditors = []
    this.$store.state.isDisableEditPresentation = false
    this.$store.state.openImportModal = false
    this.$store.commit('unsetPresentation')
  },
  methods: {
    ...mapActions('presentationReport', [
      'openReportPanelAction',
      'clearPresentationReportAction',
      'subscribeReportAction',
      'generateReportAction',
      'selectPresentationAction',
    ]),
    ...mapActions([
      'patchPresentationAction',
    ]),
    ...mapActions(['setLoadingExportPdfAction', 'setLoadingExportImageAction', 'setLoadingExportExcelAction']),
    ...mapActions('multipleSessions', ['getPresentationMasterByPresentationIdAction', 'getPresentationDetailBySessionAction', 'setSelectedSession']),
    ...mapActions('featureToggles', ['updateFeatureContext']),
    async getPresentationDetailBySession() {
      let shouldCallGetPresentation = false

      if (this.canUseMultipleSessions) {
        let { id: presentationId } = this.$route.params
        const resp = await this.getPresentationMasterByPresentationIdAction(presentationId)
        presentationId = parseInt(presentationId, 10)

        if (!resp || resp.rootPresentation.id === presentationId) {
          shouldCallGetPresentation = true
        } else {
          if (this.selectedSession && this.selectedSession.presentationId) {
            presentationId = this.selectedSession.presentationId
          }

          const res = await this.getPresentationDetailBySessionAction(presentationId)
          this.handleDataPresentationDetail(res)
          return res
        }
      } else {
        shouldCallGetPresentation = true
      }

      if (shouldCallGetPresentation) {
        await this.getPresentation()
      }

      return null
    },
    initSocket(uniqueAccessCode) {
      PresentationEditorSocketHandler.initSocket(uniqueAccessCode, this)
    },
    goToPresentationDetail() {
      const { id: presentationId } = this.$route.params
      this.$router.push({
        name: 'PresentationDetail',
        params: { id: presentationId },
      })
    },
    backToPresentation() {
      this.goToPresentationDetail()
      Utils.trackGA4AndMixpanel(eventCategories.PRESENTATION_REPORT, {
        eventAction: 'Result > Edit presentation',
        eventCategory: eventCategories.PRESENTATION_REPORT,
        ...this.reportMetricField(),
      })
    },
    _redirectToSharedWithMe() {
      this.$router.push({ name: 'SharedWithMe' })
    },
    _redirectToPresentationList() {
      this.$router.push({ name: 'Presentations' })
    },
    backToPreviousPage() {
      if (this.isPreviousRouteTeam || this.isPreviousRouteTeamFolderDetails) {
        this.$router.push({ name: 'Team' })
      } else if (this.isPreviousRouteSharedWithMe || this.isPreviousShareRouteFolderDetails) {
        this._redirectToSharedWithMe()
      } else {
        this._redirectToPresentationList()
      }
    },

    async getPresentation() {
      const { id: presentationId } = this.$route.params
      const payloadDataPresentation = {
        socketId: Socket.getSocketId(),
        admin: this.isAdmin,
      }
      const res = await this.$http.get(Config.api.getPresentationDetail + presentationId, {
        params: payloadDataPresentation,
      })
      res.body.slides = res.body.Slides
      this.handleDataPresentationDetail(res)
      return res.body
    },
    trackingHereSection(eventLabel) {
      Utils.trackGA4AndMixpanel(eventCategories.PRESENTATION_REPORT, {
        eventAction: 'Result > Hover in',
        eventLabel,
        eventCategory: eventCategories.PRESENTATION_REPORT,
        ...this.reportMetricField(),
      })
    },
    async handleDataPresentationDetail(res) {
      this.$store.state.userOnline = res.body.userOnline

      this.$store.dispatch('setPresentation', res.body)

      EventBus.$emit('setPresentationDataDone')
    },

    reload() {
      window.location.reload()
    },
    handleTabChange(tab) {
      this.selectedTab = tab
      // add query tab = tab
      this.$router.push({
        query: {
          tab,
        },
      })
      Utils.trackGA4AndMixpanel(eventCategories.PRESENTATION_REPORT, {
        eventAction: 'Report > Switch tab',
        eventLabel: tab,
        eventCategory: eventCategories.PRESENTATION_REPORT,
        ...this.reportMetricField(),
      })
    },

    setDefaultTabInEditor() {
      // get router query params
      const { tab } = this.$route.query
      if (tab === 'feedback') {
        this.selectedTab = 'feedback'
      } else {
        this.selectedTab = 'participants'
      }

      // const hasOldFeedbacks = this.privateFeedbacks && this.privateFeedbacks.length
      //
      // const comments = this.newPrivateFeedbacks
      //     && this.newPrivateFeedbacks.comments
      //     && this.newPrivateFeedbacks.comments.length
      // const ratings = this.newPrivateFeedbacks
      //     && this.newPrivateFeedbacks.ratings
      //     && this.newPrivateFeedbacks.ratings.length
      //
      // const hasNewFeedbacks = comments || ratings
      //
      // if (hasOldFeedbacks || hasNewFeedbacks) {
      //   this.selectedTab = 'feedback'
      // }
    },
    clickBreadcrumbsNLevel(folderId) {
      let name = 'FolderDetail'
      if (this.isPreviousShareRouteFolderDetails) {
        name = 'ShareFolderDetail'
      }
      this.$router.push({
        name,
        params: {
          folderId,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>

@import "@/assets/scss-v2/variables.scss";
.wrapper-report{
  padding: 24px 40px 120px 40px;
  @media (max-width: 1024px) {
    padding: 24px 0 90px;
  }
}
.wrapper-toolbox{
  @media (max-width: 1024px) {
    flex-direction: column;
  }
}
.aha-button-base{
  background: white;
}
.base-color{
  color:#525F7F;
}
.section-info-presentation{
  font-size: 16px;
  gap:22px;
  display: grid;
  grid-template-columns: repeat(3, auto);
  .text-reaction{
    font-size: 16px;
  }
  // media screen for ipad and moible
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, auto);
    gap: 10px;
  }
  @media (max-width: 768px) { // sm screens
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    .time-box-report{
      width: 100%;

    }
  }
}
.wrapper-table{
  @apply bg-base-0 gap-4  rounded-md;
}
.title-tab {
  padding: 16px 24px 0px 24px;
  border-bottom: 1px solid #ddd;

  a {
    display: inline-block;
    padding: 0 16px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    padding-bottom: 10px;
    margin-bottom: -1px;

    &.active {
      border-bottom: 3px solid #6A1EBB;
      color: #6A1EBB;
    }
  }
}

.report-panel {
  @apply bg-base-0 w-full p-4 pb-40 transition-all shadow-top bg-no-repeat;
  @apply right-0 overflow-y-scroll;
  @apply h-full fixed;
  @apply top-16;
  background-size: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  /* Hide scrollbar on IE and Edge */
  scrollbar-width: none;

  .report-panel-export {
    display: block;
  }

  &.in-editor {
    width: 100%;
    .report-panel-export {
      display: none;
    }
  }

  @media (min-width: 768px) { // sm screens
    min-height: calc(100vh - 4rem); // header height is 4rem
    width: 354px;
    &.in-editor {
      width: $rightSideWidth;
      @apply top-32;
    }
  }
}
.body-table{
  height: 400px;
  overflow-y: scroll;
  -ms-overflow-style: auto;
}

.report-engagement-rate {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px;
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px 2px 6px rgba(211, 215, 225, 0.65);
  border-radius: 8px;
}

.nav-tabs {
  display: flex;
  margin-left: -1rem;
  margin-right: -1rem;
  border-top: 1px solid #EBEBEB;

  .nav-item {
    @apply bg-secondary-15 text-center text-secondary-40 cursor-pointer;
    @apply flex justify-center items-center flex-1;
    padding: 14px;

    &.active {
      @apply bg-base-0;
      color: #191F2D;
    }
  }
}
.metric-box{
  cursor: pointer;
  img {
    width: 56px;
  }
  height:100%;
  align-items: center;
  @apply bg-base-0 gap-4 p-4 rounded-md flex flex-row;
  .text-metric{
    font-size: 24px;
    // bold
    font-weight: bold;
  }
  .text-explain-metric{
    font-size: 16px;
  }
}
.content__mobile-screen {
  @apply sm:mt-20 mt-12;
  display: none;

  text-align: center;
  @media (max-width:  1024px) {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
}
.header{
  svg{
    cursor: pointer;
  }
}
.modal__title--tab {
  padding: 0 16px;
  border-bottom: 1px solid #ddd;

  a {
    display: inline-block;
    padding: 0 16px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    padding-bottom: 10px;
    margin-bottom: -1px;

    &.active {
      border-bottom: 3px solid #6A1EBB;
      color: #6A1EBB;
    }
  }
  &.title-tab__content-wrapper {
    @apply flex overflow-x-auto overflow-y-hidden;
    padding: 16px 16px 0 16px;
  }
  .title-tab__content {
    @apply flex;
  }
}
</style>
